import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { UitkPill } from 'uitk-react-pill';
import { UitkText } from 'uitk-react-text';

export interface PopularMentionsProps {
  analytics?: AnalyticsStore;
  currentHotel?: CurrentHotelStore;
  applyCommonPhrasesFilters?: (values, shouldFetch?) => void;
}

export interface PopularMentionsState {
  keyPhrases: KeyPhraseProps[];
  pillSet: Set<string>;
}

export interface KeyPhraseProps {
  label: string;
}

@inject('currentHotel', 'analytics')
export class PopularMentions extends React.Component<PopularMentionsProps, PopularMentionsState> {
  public constructor(props: PopularMentionsProps) {
    super(props);

    const { currentHotel } = this.props;

    this.state = {
      keyPhrases:
        currentHotel && currentHotel.keyPhrases && currentHotel.keyPhrases.phrases
          ? currentHotel.keyPhrases.phrases.map((pill, index) => ({
              label: pill.text
            }))
          : [],
      pillSet: new Set()
    };
  }

  public pillsTracking = (selectedKeyPhrase: string): void => {
    const { analytics } = this.props;

    analytics.trackEvent(`Reviews.Filter.KeyPhrase[${selectedKeyPhrase}]`, 'Reviews Filter KeyPhrase', analytics.omnitureData, null);
  }

  public onPillToggle = (type: string): void => {
    const { applyCommonPhrasesFilters } = this.props;
    const { pillSet } = this.state;
    const newPinFilter = new Set(pillSet);

    if (newPinFilter.has(type)) {
      newPinFilter.delete(type);
    } else {
      newPinFilter.add(type);
    }

    this.setState({
      pillSet: newPinFilter
    });

    this.pillsTracking(type);
    applyCommonPhrasesFilters([...newPinFilter].toString(), true);
  }

  public render() {
    const { keyPhrases, pillSet } = this.state;
    const { currentHotel } = this.props;

    return (
      currentHotel.keyPhrases && (
        <div className="s-t-padding-four m-t-padding-four popular-mentions">
          <UitkText size={300} weight="bold">
            {currentHotel.keyPhrases.label}
          </UitkText>
          <div className="all-b-padding-six all-t-padding-two">
            {keyPhrases &&
              keyPhrases.map((keyPhrase, index) => {
                const handleClick = (type: string) => () => this.onPillToggle(type);

                return (
                  <UitkPill
                    key={index}
                    onChange={handleClick(keyPhrase.label)}
                    id={`keyphrase-${index}`}
                    checked={pillSet.has(keyPhrase.label)}
                    altText={keyPhrase.label}
                  >
                    {keyPhrase.label}
                  </UitkPill>
                );
              })}
          </div>
        </div>
      )
    );
  }
}
